import { LDFlagSet, useFlags } from 'launchdarkly-react-client-sdk';

export enum FeatureFlag {
  DebtorPortalAuthentication = 'DebtorPortalAuthentication',
  EnableCompanySelector = 'enable-company-selector',
  EnableNoaCenter = 'enable-noa-center',
  EnableCommunicationPreferences = 'enable-communication-preferences',
}

export const isFeatureEnabled = (
    flags: LDFlagSet,
    flag: FeatureFlag,
    variant?: boolean
): boolean => {
    const featureFlag: any = flags ? flags[flag] : null;

    if (
        typeof featureFlag === 'boolean' &&
        (featureFlag as boolean).valueOf() === true &&
        typeof variant === 'boolean' &&
        (variant as boolean).valueOf() === true
    ) {
        return true;
    }

    return false;
};


export const useFeatureFlags = () => {
    const flags = useFlags();

    const makeStandardFlag = (flag: FeatureFlag) =>
        isFeatureEnabled(flags, flag, true);

    const DebtorPortalAuthentication = makeStandardFlag(
        FeatureFlag.DebtorPortalAuthentication
    );

    const EnableCompanySelector = makeStandardFlag(
        FeatureFlag.EnableCompanySelector
    );

    const EnableNoaCenter = makeStandardFlag(
        FeatureFlag.EnableNoaCenter
    );

    const EnableCommunicationPreferences = makeStandardFlag(
        FeatureFlag.EnableCommunicationPreferences
    );

    return {
        DebtorPortalAuthentication,
        EnableCompanySelector,
        EnableNoaCenter,
        EnableCommunicationPreferences,
    };
};
